import { render, staticRenderFns } from "./MaterialIcons.vue?vue&type=template&id=4123b4af"
import script from "./MaterialIcons.vue?vue&type=script&lang=js"
export * from "./MaterialIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports